import { WithdrawBasis } from "@utils/interfaces";

export interface ResolvedWithdrawBasis {
  selected: WithdrawBasis;
  branches: WithdrawBasis[];
  withdrawBasisID: string;
}

/**
 * Regra 4: Cada endereço tem um filialIdDefault que determina a base de retirada.
 * Regra 5: Opções de centro são filtradas pela mesma branch.
 */
export function resolveWithdrawBasis(
  list: WithdrawBasis[],
  filialIdDefault?: string
): ResolvedWithdrawBasis | null {
  if (!filialIdDefault) return null;

  const selected = list.find((i) => i.filialID === filialIdDefault);
  if (!selected) return null;

  return {
    selected,
    branches: list.filter((i) => i.branch === selected.branch),
    withdrawBasisID: `${selected.shippingPoint}-${selected.branchName}`,
  };
}

/**
 * Regra 7/11: Encontra a base de retirada pelo valor composto "shippingPoint-branchName".
 */
export function findWithdrawBasisByValue(
  list: WithdrawBasis[],
  value: string
): WithdrawBasis | null {
  const [shippingPoint, ...parts] = value.split("-");
  const branchName = parts.join("-");

  return (
    list.find(
      (i) => i.shippingPoint === shippingPoint && i.branchName === branchName
    ) ?? null
  );
}

/**
 * Gera o ID composto de uma base de retirada.
 */
export function toWithdrawBasisID(basis: WithdrawBasis): string {
  return `${basis.shippingPoint}-${basis.branchName}`;
}
